import type { Tab } from '../../custom-tab-bar/type.d.ts';

export const route = {
  component: () => import('./page.vue'),
  path: '/hotel/intro',
  name: 'hotel-intro',
  meta: {
    title: '健康智能马桶',
    auth: true,
    needPhone: false,
    wechat: {
      AppMessageShare: false,
      TimelineShare: false,
      baseAuth: true,
    },
  },
};

export const tab: Tab = {
  label: '首页',
  icon: 'home-o',
  to: {
    name: route.name,
  },
};
